import React, { useState, useEffect } from "react";
import Scrollbar from "react-scrollbars-custom";
import DefaultTeamAvatar from "assets/img/HandsColorAvatar.jpeg";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquare, faCheckSquare } from "@fortawesome/free-solid-svg-icons";
import Avatar from "components/Avatar";

var styles = {
  headingDailog: {
    display: "flex",
    justifyContent: "center",
    padding: "5px 0",
  },
  listItem: {
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
    padding: "10px",
    margin: "5px",
    boxShadow: "0px 5px 15px #ccc",
  },
  teamDetail: {
    display: "flex",
    gap: "10px",
    fontWeight: "400",
    alignItems: "center",
  },
  listContainer: {
    display: "flex",
    flexDirection: "column",
    marginRight: "5px",
  },
  dialogContent: {
    height: "450px",
    maxHeight: "450px",
    overflow: "auto",
  },
  avatar: {
    minHeight: "30px",
    height: "40px",
    minWidth: "30px",
    width: "40px",
  },
  teamName: {
    paddingLeft: "5px",
    color: "#575F6B",
  },
  teamNameAll: {
    paddingLeft: "5px",
    color: "#575F6B",
    fontWeight: "bolder",
  },
  uncheckbox: {
    cursor: "pointer",
    fontSize: "35px",
    color: "white",
    border: "1px solid #999",
    borderRadius: "5px",
  },
  checkbox: {
    cursor: "pointer",
    fontSize: "35px",
    color: "#000000",
  },
  noTeams: {
    display: "flex",
    justifyContent: "center",
    fontWeight: 200,
    color: "red",
  },
  shareButton: {
    cursor: "pointer",
  },
  actionButton: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    textAlign: "center",
  },
};

export default ({
  myteam_id,
  formik,
  selectTeams,
  selectedTeams,
  disabled,
}) => {
  const classes = styles;
  const [allTeams, setAllTeams] = useState();
  const [shareteams, setSharedTeams] = useState([]);
  const [shareAllTeam, setShareAllTeam] = useState(false);
  const { teams } = useSelector((state) => state.teamsReducer);

  useEffect(() => {
    if (teams === undefined) {
      return;
    }

    setAllTeams(
      teams.filter((all_teams) => {
        return all_teams?.id !== myteam_id;
      })
    );
  }, [teams, myteam_id]);

  useEffect(() => {
    setSharedTeams(selectedTeams);
    selectTeams(selectedTeams);
    setShareAllTeam(selectedTeams?.length === allTeams?.length ? true : false);
  }, [selectedTeams, selectTeams, allTeams]);

  const onTeamSelect = (team) => {
    setSharedTeams([...shareteams, team]);
    selectTeams([...shareteams, team]);
  };

  const discardTeam = (team) => {
    setSharedTeams(
      shareteams.filter((shareteams) => {
        return shareteams !== team;
      })
    );
    selectTeams(
      shareteams.filter((shareteams) => {
        return shareteams !== team;
      })
    );
  };

  const toggleSelectTeam = () => {
    setShareAllTeam(!shareAllTeam);
    setSharedTeams(
      !shareAllTeam
        ? allTeams.map((all_teams) => {
            return all_teams?.id;
          })
        : []
    );
    selectTeams(
      !shareAllTeam
        ? allTeams.map((all_teams) => {
            return all_teams?.id;
          })
        : []
    );
  };
  return (
    <>
      <Scrollbar
        style={{
          paddingRight: "10px",
          position: "absolute",
          width: "92%",
          height: "54vh",
        }}
      >
        <div style={classes.listContainer}>
          {allTeams?.length > 0 && (
            <div style={classes.listItem}>
              <div style={classes.teamDetail}>
                <span style={classes.teamNameAll}>
                  {shareAllTeam ? "Remove All" : "Select All"}
                </span>
              </div>
              {!shareAllTeam && (
                <FontAwesomeIcon
                  icon={faSquare}
                  style={classes.uncheckbox}
                  onClick={toggleSelectTeam}
                />
              )}
              {shareAllTeam && (
                <FontAwesomeIcon
                  icon={faCheckSquare}
                  style={classes.checkbox}
                  onClick={toggleSelectTeam}
                />
              )}
            </div>
          )}

          {allTeams?.map((allteam) => (
            <div style={classes.listItem} key={allteam.id}>
              <div style={classes.teamDetail}>
                <Avatar
                  alt={allteam.avatar}
                  rootStyle={classes.avatar}
                  src={allteam.avatar ?? DefaultTeamAvatar}
                />
                <span style={classes.teamName}>{allteam.name}</span>
              </div>
              {!shareteams.includes(allteam.id) && (
                <FontAwesomeIcon
                  icon={faSquare}
                  style={classes.uncheckbox}
                  onClick={() => {
                    if (onTeamSelect && !disabled) {
                      onTeamSelect(allteam.id);
                    }
                  }}
                />
              )}
              {shareteams.includes(allteam.id) && (
                <FontAwesomeIcon
                  icon={faCheckSquare}
                  style={classes.checkbox}
                  onClick={() => {
                    if (onTeamSelect && !disabled) {
                      discardTeam(allteam.id);
                    }
                  }}
                />
              )}
            </div>
          ))}
          {allTeams?.length === 0 && (
            <div style={classes.noTeams}>
              <p>You don't have any teams.</p>
            </div>
          )}
        </div>
      </Scrollbar>
    </>
  );
};
